import '../sass/frontend.scss';
import Factory from "./frontend/app/factory";

jQuery(function(){
    Factory.make().eventHandler()
        .default();
});
